export enum CountryRegions {
  CE_REGION = 1,
  FRENCH_BLOCK = 2
}
